import { useTheme } from "../contexts/ThemeContext";

export default function CircleToolIcon({
    fillClassName,
}: {
    fillClassName: string;
}) {
    const { theme } = useTheme();
    return (
        <svg
            width="17"
            height="13"
            viewBox="0 0 17 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.61893 10.9726C3.95222 10.9726 0.969391 8.51488 0.969391 5.49236C0.969391 2.46985 3.95222 0.012146 7.61893 0.012146C11.2856 0.012146 14.2685 2.46985 14.2685 5.49236C14.2685 8.51488 11.2856 10.9726 7.61893 10.9726ZM7.61893 1.53867C4.79486 1.53867 2.49591 3.31249 2.49591 5.49236C2.49591 7.67224 4.79486 9.44606 7.61893 9.44606C10.443 9.44606 12.7419 7.67224 12.7419 5.49236C12.7419 3.31249 10.443 1.53867 7.61893 1.53867Z"
                fill={fillClassName}
            />
            <path
                d="M11.42 11.8641C11.0353 11.8641 10.6995 11.6046 10.6079 11.229L9.35917 6.17013C9.29811 5.91978 9.35306 5.66027 9.51182 5.45572C9.67058 5.25116 9.90872 5.13515 10.1682 5.13515C10.2354 5.13515 10.3056 5.14431 10.3728 5.15957L15.4286 6.40827C15.7217 6.48154 15.9507 6.70441 16.0331 6.99445C16.1125 7.28449 16.0331 7.5959 15.8194 7.80656L12.0092 11.6168C11.8505 11.7755 11.6428 11.861 11.42 11.861V11.8641Z"
                fill={fillClassName}
            />
            <path
                d="M10.1682 5.59616C10.1988 5.59616 10.2293 5.59922 10.2598 5.60838L13.1541 6.32279L14.0273 6.53956L15.3187 6.86013C15.6026 6.93035 15.7003 7.2845 15.4958 7.49211L11.6856 11.3023C11.6093 11.3786 11.5146 11.4122 11.42 11.4122C11.2582 11.4122 11.0994 11.3054 11.0536 11.1252L10.5712 9.17739L10.3575 8.30727L9.80491 6.06633C9.74385 5.82209 9.93314 5.59922 10.1682 5.59922M10.1682 4.6833C9.76828 4.6833 9.39886 4.86343 9.15156 5.18095C8.90427 5.49541 8.81878 5.89842 8.91648 6.28615L9.46908 8.52709L9.68279 9.39721L10.1652 11.3451C10.3087 11.9221 10.8246 12.3281 11.42 12.3281C11.765 12.3281 12.0886 12.1938 12.3328 11.9496L16.143 8.13935C16.4728 7.80962 16.5979 7.32724 16.4728 6.87844C16.3476 6.42965 15.9904 6.0816 15.5385 5.97169L14.2471 5.65112L13.3739 5.43435L10.4796 4.71994C10.3758 4.69552 10.272 4.6833 10.1682 4.6833Z"
                fill={theme === "dark" ? "#7A8590" : "#CEE0EF"}
            />
        </svg>
    );
}
